import { ReactComponent as PoweredByIgnosisLogo } from '../../../../Assets/CommonTenant/powered-by-ignosis.svg';
import { showPoweredByIgnosis } from '../../utils/configUtils';
import styles from './index.module.css';

interface PoweredByIgnosisProps {
  showBottomPadding?: boolean;
}

export const PoweredByIgnosis = ({ showBottomPadding = false }: PoweredByIgnosisProps) => {
  if (!showPoweredByIgnosis()) {
    return null;
  }

  return (
    <div className={styles.title} style={{ paddingBottom: showBottomPadding ? 16 : 0 }}>
      Powered by
      <PoweredByIgnosisLogo height={10} />
    </div>
  );
};
